<template>
    <div class="card card-default">
        <div class="card-body">
            <form role="form" class="form">
                <!-- Dates -->
                <div class="form-group">
                    <label class="">Start Date</label>
                    <t-datepicker v-model="scheduleForm.start_date"></t-datepicker>
                    <span class="invalid-feedback" v-show="scheduleForm.errors.has('start_date')">
                        {{ scheduleForm.errors.get('start_date') }}
                    </span>
                </div>

                <div class="form-group">
                    <label class="">End Date</label>
                    <t-datepicker v-model="scheduleForm.end_date"></t-datepicker>
                    <span class="invalid-feedback" v-show="scheduleForm.errors.has('end_date')">
                        {{ scheduleForm.errors.get('end_date') }}
                    </span>
                </div>

                <!-- Update Button -->
                <div class="form-group">
                    <button type="submit" class="btn btn-secondary w-100" @click.prevent="saveSchedule" :disabled="scheduleForm.busy">
                        Save Schedule
                    </button>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        schedule: {},
    },
    data() {
        return {
            scheduleForm: new SparkForm({
                start_date: this._get(this.schedule, 'start_date'),
                end_date: this._get(this.schedule, 'end_date'),
            }),
        };
    },
    methods: {
        saveSchedule() {
            Spark.post('/api/team/team-schedules', this.scheduleForm).then((response) => {
                this.$noty.success('Schedule Saved');
            });
        },
    },
};
</script>
